import React from 'react';
import { KiwiHarness } from './components/KiwiHarness';

const App: React.FC = () => {
  return <KiwiHarness />;
};

export default App;